import { PremiseTag } from 'app/premises/Premise';
import { FC } from 'react';

export type IncludedInRentIconProps = { tag?: PremiseTag };

export const IncludedInRent: FC<IncludedInRentIconProps> = ({ tag }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-label={tag}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.286 1.5a2.169 2.169 0 0 1 1.701.767l6.116 6.109a1.353 1.353 0 0 1 0 1.912l-4.817 4.816a1.353 1.353 0 0 1-1.913 0L2.16 8.897a1.802 1.802 0 0 1-.155-.18A2.17 2.17 0 0 1 1.5 7.281l.077-4.377a1.351 1.351 0 0 1 1.328-1.328l4.38-.076zm.532 1.106a1.169 1.169 0 0 0-.511-.106h-.003l-4.381.077a.353.353 0 0 0-.346.345L2.5 7.3v.002a1.17 1.17 0 0 0 .278.78l.011.014.01.014c.023.03.047.059.072.085l6.209 6.202a.353.353 0 0 0 .499 0l4.818-4.816a.354.354 0 0 0 .076-.383.352.352 0 0 0-.076-.114l-6.15-6.142-.014-.019a1.168 1.168 0 0 0-.415-.317z"
      fill="#037A35"
    />
    <path d="M5.121 5.121a1 1 0 1 0-1.414-1.414 1 1 0 0 0 1.414 1.414z" fill="#037A35" />
  </svg>
);
